import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import client, { apiError } from '../api/client';
import { useAuth } from '../context';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/login', form);
      if (data.mfaRequired) {
        sessionStorage.setItem('pmp_mfa_token', data.mfaToken);
        navigate('/mfa');
        return;
      }
      login(data.token, data.user);
      navigate(data.user.role === 'student' ? '/dashboard' : '/admin');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.needsVerification) {
        setInfo('Please verify your email first.');
        setTimeout(() => navigate(`/verify?email=${encodeURIComponent(form.email)}`), 900);
        return;
      }
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Welcome back</h1>
        <p className="muted small">Sign in to continue revising.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        {info && <div className="alert alert-info" style={{ marginBottom: 14 }}>{info}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={form.email} onChange={set('email')} required />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={form.password} onChange={set('password')} required />
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Sign in'}
          </button>
        </form>
        <div className="row-between" style={{ marginTop: 16 }}>
          <Link className="small" to="/forgot">Forgot password?</Link>
          <Link className="small" to="/register">Create account</Link>
        </div>
      </div>
    </div>
  );
}
